module.exports = __webpack_public_path__ + "static/media/no_results.36010b00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/speed_dating/no_results.svg
// module id = 485
// module chunks = 0